<component v-bind:is="getContainerType" v-bind:class="getClassName">
    <div v-if="getCimpressNoQuantity">
        <table v-if="getCimpressNoQuantityAllValuesSelected">
            <tr class="matrix_quantityTableHeader">
                <th></th>
                <th v-for="(colHeader, key) in getCimpresPricesMatrixQtyHeaders" v-bind:key="key">{{ translatePageOption(colHeader) }}</th>
            </tr>
            <tr v-for="(qtyRow,key) in getCimpresPricesMatrixQtyData" v-bind:key="key">
                <td class="matrix_quantityTablePriceDisabled">{{qtyRow.quantity}} {{$t('Pcs')}}</td>
                <td v-for="(colPriceHeader, priceKey) in getCimpresPricesMatrixQtyHeaders" v-bind:key="priceKey"
                    v-on:click="setPriceMatrixSelection(qtyRow.quantity, colPriceHeader)"
                    :class="[activeClassPriceMatrix(qtyRow.quantity, colPriceHeader),qtyRow[colPriceHeader] ? '' : 'matrix_quantityTablePriceDisabled']">
                    {{qtyRow[colPriceHeader] ? qtyRow[colPriceHeader].formatted_base_price : ""}}
                </td>
            </tr>
        </table>
        <div v-else>
            {{$t('Please complete the selection')}}
        </div>
    </div>
    <div v-else>
        <table v-if="getIsCimpressSelectionResolved">
            <tr class="matrix_quantityTableHeader">
                <th v-for="(colHeader, key) in getColHeaders" v-bind:key="key">{{ $t(colHeader) }}</th>
            </tr>
            <tr v-for="(qtyRow,key) in getQuantities" v-bind:key="key"
                v-on:click="setQuantityDebounce(qtyRow.quantity, qtyRow.code)" v-bind:class="activeClass(qtyRow.active)">
                <td>{{qtyRow.quantity}} {{$t('Pcs')}}</td>
                <td v-if="canDisplayNetPrice()">{{qtyRow.formatted_base_price ? qtyRow.formatted_base_price :
                    $n(qtyRow.base_price, 'currency')}}</td>
                <td v-if="canDisplayGrossPrice()">{{qtyRow.formatted_gross_price ? qtyRow.formatted_gross_price :
                    $n(qtyRow.gross_price, 'currency')}}</td>
            </tr>
        </table>
        <div v-else>
            {{$t('Please complete the selection')}}
        </div>
    </div>
</component>
